export const UPDATE_TAGS = "UPDATE_TAGS";
export const UPDATE_CURRENT_TAG = "UPDATE_CURRENT_TAG";

export const UPDATE_USER_ACTIVITIES = "UPDATE_USER_ACTIVITIES";
export const REMOVE_USER_ACTIVITY = "REMOVE_USER_ACTIVITY";
export const UPDATE_USER_ACTIVITY = "UPDATE_USER_ACTIVITY";

export const UPDATE_EDIT_ACTIVITY = "UPDATE_EDIT_ACTIVITY";